import { useSyncExternalStore } from "react";

type Platform = "android" | "ios" | "other";

const ANDROID = /android/i;
const IOS = /(iphone|ipad|ipod)/i;

const getPlatform = (): Platform => {
  const userAgent = navigator.userAgent;

  if (ANDROID.test(userAgent)) {
    return "android";
  }
  if (IOS.test(userAgent)) {
    return "ios";
  }

  return "other";
};

// The user agent never changes, so there is nothing to subscribe to.
const subscribe = () => () => undefined;

// The server cannot see the user agent, so SSR and hydration render with
// `null` ("not detected yet") and React re-renders with the client value right
// after. Reading navigator during render instead left SSR attributes (e.g. the
// App Store link for Android users) unpatched after a hydration mismatch.
export const useCheckPlatform = (): Platform | null =>
  useSyncExternalStore(subscribe, getPlatform, () => null);
